export default "__VITE_ASSET__CcEQvg9N__"